import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const IconMultiLine = props => (
  <SvgIcon {...props} viewBox="0 0 18 16">
    <path d="m3 0h4v2h-1v12h1v2h-4v-2h1v-12h-1v-2zm-1 4h-2v8h2v-8zm6 8h10v-8h-10v8z" />
  </SvgIcon>
);

export default IconMultiLine;



// WEBPACK FOOTER //
// ./src/components/icons/IconMultiLine.js